import { Component } from '@angular/core';

import { FormFieldComponent } from '../form-field.types';
import { QUILL_MODULES_TEXTAREA } from '@shared/Utils/quill-editor.utils';

@Component({
  templateUrl: './textarea-form-field.component.html',
  styles: [
    `
      :host ::ng-deep .textarea-quill-editor .ql-editor {
        @apply h-auto w-full overflow-auto resize-y;
        min-height: 180px;
        max-height: 500px;
      }
    `,
  ],
})
export class TextAreaFormFieldComponent extends FormFieldComponent {
  public quillModules = QUILL_MODULES_TEXTAREA;

  public editing: boolean = false;
  public value: string;

  private _originalValue: string;
  private _readonly: boolean;

  ngOnInit(): void {
    super.ngOnInit();

    this.value = this.fieldDef.meta?.value_hidden && !this.editing ? 'REDACTED' : this.model[this.fieldDef.name];
    this._originalValue = this.value;

    if (this.fieldDef.meta && this.fieldDef.meta.readonly) {
      this._readonly = this.fieldDef.meta.readonly;
    }
    if (this.readonly) {
      this._readonly = this.readonly;
    }
    this.readonly = this._readonly;
  }

  edit(): void {
    if (!this.editing && !this._readonly) {
      this.editing = true;
    }
  }

  onBlur(): void {
    this.onSave();
    this.editing = false;
  }

  updateChangedModel(model: any): void {
    this.model = model;
    this.value = this.model[this.fieldDef.name];
    this._originalValue = this.value;
  }

  onSave(): void {
    if (this._originalValue != this.value) {
      this.updateModel();
      this.update.emit({ [this.fieldDef.name]: this.value });
    }
  }

  private updateModel(): void {
    this.model[this.fieldDef.name] = this.value;
    this._originalValue = this.value;
  }
}
